import { useContext, useState } from 'react'
// import { CanvasContext } from '../../EditLessonPage'
import { CanvasContext } from '../../hooks/LessonPage'
import SearchServiceGoogleAPI from '../../LessonComponents/SearchServiceGoogleAPI'

// import { getPixabayImages, PixabayImage } from '@services/pixabay'
// import { useDebounce } from 'use-debounce'
// import { useHandlers } from '@/uibox'

function WebSearch() {
  const { actions } = useContext(CanvasContext);

  const setItem = (param) =>
  {
      // var type = param.type === "youtube" ? "VIDEO" : "WEB"
      var data = {}
      if (param.type === "youtube")
      {
         data = {type : "VIDEO",
          url : "https://www.youtube.com/watch?v="+ param.videoId, 
          videoimage : param.image,
          videoid : param.videoId
         }        
      }

      if (param.type === "google.search")
      {
        data = {type : "WEB", url : param.image, defaultcontent : param.link}     
      }      

      if (param.type === "google.image")
      {
        data = {type : "IMAGE", url : param.image, defaultContent : ""}   
      }           
      actions?.addElement(data);
  }

  return (
    <>
      <SearchServiceGoogleAPI type={1} add={setItem}/>
    </>
  )
}
export default WebSearch
